export default __webpack_public_path__ + "static/media/spark_15.1e0c947e.png";